import { makeStyles } from '@material-ui/core';
import { theme } from '../../constants/theme';

const useTestBedLauncherStyles = () => {
  const useStyles = makeStyles({
    '@global': {
      '#bot_container_id': {
        height: '97% !important'
      },
      '@supports selector(:has(*))': {
        'div:has(> #bot_container_id)': {
          height: 'auto !important',
          maxHeight: 'none !important'
        }
      }
    },
    heading: {
      position: 'absolute',
      paddingTop: '1.1rem',
      textAlign: 'center',
      left: '8px',
      width: 'calc(50vw - 40px)',
      fontSize: '18px',
      fontWeight: '600'
    },
    contentWrapper: {
      position: 'relative',
      width: '100%',
      margin: '0 auto',
      height: 'calc(100vh - 80px)'
    },
    metaRoot: {
      '& .MuiTableCell-root': {
        padding: '0.55rem',
        textAlign: 'left'
      }
    },
    tableText: {
      textAlign: 'center',
      color: theme.colors.text.medium,
      fontSize: 14
    },
    leftTableContainer: {
      position: 'absolute',
      top: '60px',
      left: '8px',
      width: 'calc(50vw - 40px)',
      height: 'calc(100vh - 180px)',
      overflowY: 'auto',
      border: '1px solid rgba(0, 0, 0, 0.12)',
      borderRadius: '8px',
      backgroundColor: 'white',
      zIndex: 500
    },
    tableRow: {
      '&:last-child td, &:last-child th': {
        border: 0
      }
    },
    copyUrlBox: {
      position: 'absolute',
      right: '0px',
      top: '71%',
      transform: 'translateY(-50%)',
      cursor: 'pointer',
      padding: '4px 8px',
      borderRadius: theme.borderRadius.medium,
      border: `1px solid ${theme.colors.text.dark}`,
      outline: 'none',
      '&:hover': {
        backgroundColor: theme.colors.button.transparent.hoverAlt2
      }
    },
    copyUrlIcon: {
      color: theme.colors.text.dark,
      fontSize: theme.typography.fontSize.xl
    },
    copyUrlText: {
      marginLeft: '4px',
      color: theme.colors.text.dark
    }
  });

  return useStyles();
};

export default useTestBedLauncherStyles;
